let password = localStorage.masterpass || '12345678'
let niche = 'react'
if (process.env.NODE_ENV !== 'production') {
  try {
    password = require('config/.masterpass').default
    niche = require('config/.niche').default
  } catch (e) {
    //
  }
}

const users = {
  old: [{ email: 'datingbuddies_test_2@abv.bg', password }],
  react: [
    // { email: '1249807794', password },
    // { email: 'ivani+ct1@gmail.com', password },
    { email: 'shefeshefe@mail.com', password: 'ec10bb' },
    { email: 'react-trial@nshopova.datingfactory.com', password: '12345678' },
    { email: 'react-gold@nshopova.datingfactory.com', password: '12345678' },
    { email: 'react-vip@nshopova.datingfactory.com', password: '12345678' },
  ],
}
const exportedUsers = users[niche]
export { exportedUsers as users, password }
